import Modal from './Modal';

const Contact = (function () {
    const form = document.querySelector('.contact__form');
    const input = form?.querySelector('.contact__input');

    const getCurrentDateTime = () => {
        return new Intl
            .DateTimeFormat('uk-UA', {
                dateStyle: 'short',
                timeStyle: 'short'
            })
            .format(new Date())
    }

    async function handleSubmit(e) {
        e.preventDefault();

        form.classList.add('disabled');
        input.setAttribute('disabled', true)

        const submitTime = getCurrentDateTime()
        const userData = JSON.stringify({
            "data": {
                "Date": String(submitTime),
                "Email": String(input.value)
            }
        })

        try {
            const response = await fetch('https://api.apispreadsheets.com/data/pdFnQX0Ykp1OAw2f/', {
                method: "POST",
                headers: {"accessKey": "e3bd973840fbf239646bbd848105274f", "secretKey": "2814e9e2b68d24129ccd76276c231491"},
                body: userData,
            })

            if (response.ok) {
                input.value = '';
                input.blur()
                Modal.open(this.dataset.success);
                form.classList.remove('disabled');
                input.removeAttribute('disabled')
            } else {
                Modal.open(this.dataset.error);
                form.classList.remove('disabled')
                input.removeAttribute('disabled')
            }
        } catch (err) {
            console.log('Request failed with error: ', err.message);
        }
    }

    return {
        init: () => form && form.addEventListener('submit', handleSubmit)
    };
})();

export default Contact;